import React from "react";
import { GenerateWrapper, GenerateContainer, GenerateContent } from "./style";

const Generate = () => {
  return (
    <GenerateWrapper>
      <GenerateContainer>
        <GenerateContent>
          <span data-aos="fade-down">Stellar Edit</span>
          <h1 data-aos="fade-down">Go Beyond what's possible</h1>
        </GenerateContent>
        <img src="/assets/generate.png" alt="Expand your imagination" data-aos="fade-down" />
      </GenerateContainer>
    </GenerateWrapper>
  );
};

export default Generate;
